'use client';

import { createTheme } from '@mantine/core';
import base from './base';

const theme = createTheme({
	...base,
	primaryShade: 9,
	colors: {
		igluBlack: [
			'#151515',
			'#1a1a1a',
			'#202020',
			'#262626',
			'#2c2c2c',
			'#333333',
			'#393939',
			'#404040',
			'#464646',
			'#4d4d4d',
		],
		igluTextPrimary: [
			'#e2e2e2',
			'#d2d2d2',
			'#c2c2c2',
			'#b2b2b2',
			'#a2a2a2',
			'#929292',
			'#828282',
			'#727272',
			'#626262',
			'#505058',
		],
		igluPrimaryHover: [
			'#0b1b3a',
			'#11224b',
			'#162a5c',
			'#1b326d',
			'#1f397e',
			'#23408f',
			'#2847a0',
			'#2c4eb1',
			'#3155c2',
			'#365cd3',
		],
		igluSidebarButtonHover: [
			'#1f2a3f',
			'#232f47',
			'#28354f',
			'#2c3a57',
			'#31405f',
			'#354567',
			'#394a6f',
			'#3e5077',
			'#42557f',
			'#475b87',
		],
		igluPrimary: [
			'#19305a',
			'#1d3664',
			'#213c6e',
			'#254278',
			'#294882',
			'#2d4e8c',
			'#315496',
			'#355aa0',
			'#3960aa',
			'#3d66b4',
		],
		igluTextSecondary: [
			'#9fa4b7',
			'#a8adc0',
			'#b1b6c9',
			'#babfd2',
			'#c3c8db',
			'#ccd1e4',
			'#d5daed',
			'#dee3f6',
			'#e7ecff',
			'#f0f5ff',
		],
		igluSecondary: [
			'#97aac1',
			'#a1b2c8',
			'#abbad0',
			'#b5c2d7',
			'#bfcae0',
			'#c9d2e7',
			'#d3daef',
			'#dde2f7',
			'#e7eaff',
			'#f1f2ff',
		],
		igluDisabledText: [
			'#bac6d8',
			'#c3cfe0',
			'#ccd8e8',
			'#d5e1f0',
			'#deeaf8',
			'#e7f3ff',
			'#f0fcff',
			'#f9ffff',
			'#ffffff',
			'#ffffff',
		],
		igluBorder: [
			'#d4dde7',
			'#dbe2ea',
			'#e2e9ed',
			'#e9f0f1',
			'#f0f7f5',
			'#f7fef9',
			'#ffffff',
			'#ffffff',
			'#ffffff',
			'#ffffff',
		],
		igluTextButton: [
			'#021df4',
			'#2338f6',
			'#4453f8',
			'#6570fa',
			'#868bfc',
			'#a7a6fe',
			'#c8c1ff',
			'#e9dcff',
			'#faf7ff',
			'#ffffff',
		],
		igluInnerForm: [
			'#23272e',
			'#272b33',
			'#2b2f38',
			'#2f333d',
			'#333742',
			'#373b47',
			'#3b3f4c',
			'#3f4351',
			'#434756',
			'#474b5b',
		],
		igluBackground: [
			'#15171a',
			'#1a1c1f',
			'#1f2124',
			'#24262a',
			'#292b2f',
			'#2e3034',
			'#333539',
			'#383a3e',
			'#3d3f43',
			'#424448',
		],
		igluSurface: [
			'#1c1e22',
			'#222429',
			'#282b30',
			'#2e3137',
			'#34373e',
			'#3a3d45',
			'#40434c',
			'#464953',
			'#4c4f5a',
			'#525561',
		],
		igluRed: [
			'#620404',
			'#a50607',
			'#bc140d',
			'#d21b11',
			'#ec281c',
			'#ee4f46',
			'#f37870',
			'#f8a7a3',
			'#fed4d2',
			'#ffeae9',
		],
		igluRedMid: [
			'#b82c4b',
			'#c43a5a',
			'#d04869',
			'#dc5678',
			'#e86487',
			'#f47296',
			'#ff80a5',
			'#ffb3c1',
			'#ffd6e0',
			'#fff0f5',
		],
		igluRedLight: [
			'#fee5eb',
			'#fdd3df',
			'#fcc1d3',
			'#fbb0c7',
			'#fa9ebb',
			'#f98caf',
			'#f87ba3',
			'#f76997',
			'#f6578b',
			'#f5457f',
		],
		igluGreen: [
			'#00391f',
			'#00522c',
			'#006b39',
			'#008446',
			'#009d53',
			'#00a656',
			'#2c9c5e',
			'#5bb282',
			'#8ac8a6',
			'#b9dec9',
		],
		igluGreenMid: [
			'#1e4d3a',
			'#25644c',
			'#2c7b5e',
			'#339270',
			'#3aa982',
			'#41c094',
			'#48d7a6',
			'#6ee2bc',
			'#94edd2',
			'#baf3da',
		],
		igluGreenLight: [
			'#0f3d2b',
			'#16644a',
			'#1d8b69',
			'#24b288',
			'#2bd9a7',
			'#32ffca',
			'#6bffd7',
			'#a4ffe4',
			'#ddf9ed',
			'#f6fff9',
		],
		igluBlue: [
			'#142a4a',
			'#19335e',
			'#1e3c72',
			'#234586',
			'#284e9a',
			'#2a85ff',
			'#4b9aff',
			'#6cb0ff',
			'#8dc5ff',
			'#e8f4ff',
		],
		igluBlueLight: [
			'#1a2633',
			'#22344a',
			'#2a4261',
			'#325078',
			'#3a5e8f',
			'#427ca6',
			'#4a9abd',
			'#52b8d4',
			'#5ad6eb',
			'#e1f4ff',
		],
		igluYellow: [
			'#3d2a00',
			'#5c4000',
			'#7b5500',
			'#9a6b00',
			'#b98000',
			'#ffd21c',
			'#ffe066',
			'#ffeda1',
			'#fff9dc',
			'#fffbe8',
		],
		igluYellowLight: [
			'#665200',
			'#7f6500',
			'#997800',
			'#b28b00',
			'#cca000',
			'#e5b500',
			'#ffca00',
			'#ffe066',
			'#fff4b3',
			'#fffbe8',
		],
	},
});

export default theme;
